import { useNavigate } from 'react-router'
import { Button, Flex } from 'antd'
import FloatingActionButtonContainer from 'ui/FloatingActionButtonContainer/FloatingActionButtonContainer'

interface InvoiceBottomBarActionProps {
  isUpdate?: boolean
}

const InvoiceBottomBarAction = ({
  isUpdate = false,
}: InvoiceBottomBarActionProps) => {
  const navigate = useNavigate()

  const handleCancel = () => {
    navigate(-1)
  }

  return (
    <FloatingActionButtonContainer>
      <Flex justify="end" gap="1rem">
        <Button type="link" onClick={handleCancel}>
          Cancel
        </Button>
        <Button type="primary" htmlType="submit">
          {isUpdate ? 'Update invoice' : 'Save invoice'}
        </Button>
      </Flex>
    </FloatingActionButtonContainer>
  )
}

export default InvoiceBottomBarAction
